import React from 'react';
import classnames from 'classnames';
import Select from 'src/components/ui/Select';
import styles from './styles.module.scss';

type Props = {
  label?: string;
  error?: string;
  className?: string;
  [x: string]: any;
}

const SelectField: React.FC<Props> = ({ label, error, className, ...rest }) => {
  const fieldClassNames = classnames(styles['select-field'], className);
  
  return (
    <div className={fieldClassNames}>
      {label && <div className={styles['label']}>{label}</div>}
      <Select {...rest} />
      {error && <div className={styles['error']}>{error}</div>}
    </div>
  );
};

export default SelectField;
